export default __webpack_public_path__ + "static/media/table.8f0ff163.svg";